import { render, staticRenderFns } from "./Ssa.vue?vue&type=template&id=437b5beb&"
import script from "./Ssa.vue?vue&type=script&lang=js&"
export * from "./Ssa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports